'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InlineSummaryEditor = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _baseBcReactComponent = require('@bibliocommons/base-bc-react-component');

var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);

var _baseAlerts = require('@bibliocommons/base-alerts');

var _simpleUgcDisplay = require('../../simple-ugc-display');

var _simpleUgcDisplay2 = _interopRequireDefault(_simpleUgcDisplay);

var _simpleUgcForm = require('../../simple-ugc-form');

var _simpleUgcForm2 = _interopRequireDefault(_simpleUgcForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var InlineSummaryEditor = exports.InlineSummaryEditor = function (_BcReactComponent) {
  _inherits(InlineSummaryEditor, _BcReactComponent);

  function InlineSummaryEditor() {
    _classCallCheck(this, InlineSummaryEditor);

    return _possibleConstructorReturn(this, (InlineSummaryEditor.__proto__ || Object.getPrototypeOf(InlineSummaryEditor)).apply(this, arguments));
  }

  _createClass(InlineSummaryEditor, [{
    key: 'componentDidMount',
    value: function componentDidMount() {/* For Testing purposes */}
  }, {
    key: 'renderMessaging',
    value: function renderMessaging() {
      var _props = this.props,
          status = _props.status,
          pending = _props.pending;

      var infoMessage = _react2.default.createElement(
        _baseAlerts.AlertInfo,
        null,
        _react2.default.createElement('span', { className: 'icon-spinner' }),
        'Submitting summary...'
      );
      var successMessage = _react2.default.createElement(
        _baseAlerts.AlertSuccess,
        null,
        'Summary Saved'
      );
      var failureMessage = _react2.default.createElement(
        _baseAlerts.AlertFailure,
        null,
        _react2.default.createElement('span', { className: 'icon-ok' }),
        'Could not save summary.'
      );
      return _react2.default.createElement(
        'div',
        null,
        pending ? infoMessage : null,
        status === 'success' ? successMessage : null,
        status === 'failure' ? failureMessage : null
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          characterLimit = _props2.characterLimit,
          summary = _props2.summary,
          handleCancel = _props2.handleCancel,
          handleChange = _props2.handleChange,
          handleDelete = _props2.handleDelete,
          handleShowForm = _props2.handleShowForm,
          handleSubmit = _props2.handleSubmit,
          bibId = _props2.bibId,
          isPrivate = _props2.isPrivate,
          handlePrivacyToggle = _props2.handlePrivacyToggle,
          rating = _props2.rating,
          showForm = _props2.showForm,
          user = _props2.user;


      if (showForm) {
        return _react2.default.createElement(
          'div',
          { className: 'cp-inline-summary-editor well' },
          this.renderMessaging(),
          _react2.default.createElement(_simpleUgcForm2.default, {
            ugcType: 'summary',
            characterLimit: characterLimit,
            body: summary,
            handleCancel: handleCancel,
            handleChange: handleChange,
            handleSubmit: handleSubmit,
            handleDelete: handleDelete,
            isNew: false,
            placeholderText: 'summary_field_placeholder',
            submitButtonText: 'update_summary',
            formHeadingText: 'enter_a_summary' }),
          _react2.default.createElement('div', { className: 'clear' })
        );
      }

      return _react2.default.createElement(
        'div',
        null,
        this.renderMessaging(),
        _react2.default.createElement(_simpleUgcDisplay2.default, {
          user: user,
          bibId: bibId,
          isPrivate: isPrivate,
          handlePrivacyToggle: handlePrivacyToggle,
          ugcType: 'summary',
          body: summary,
          rating: rating / 2,
          handleDelete: handleDelete,
          handleShowForm: handleShowForm })
      );
    }
  }]);

  return InlineSummaryEditor;
}(_baseBcReactComponent2.default);

InlineSummaryEditor.propTypes = {
  characterLimit: _react.PropTypes.number,
  summary: _react.PropTypes.string,
  bibId: _react.PropTypes.number.isRequired,
  handlePrivacyToggle: _react.PropTypes.func.isRequired,
  isPrivate: _react.PropTypes.bool.isRequired,
  handleCancel: _react.PropTypes.func.isRequired,
  handleChange: _react.PropTypes.func.isRequired,
  handleDelete: _react.PropTypes.func.isRequired,
  handleShowForm: _react.PropTypes.func.isRequired,
  handleSubmit: _react.PropTypes.func.isRequired,
  pending: _react.PropTypes.bool.isRequired,
  rating: _react.PropTypes.number,
  user: _react.PropTypes.shape({
    loggedIn: _react.PropTypes.bool
  }),
  showForm: _react.PropTypes.bool.isRequired,
  status: _react.PropTypes.string.isRequired
};

exports.default = InlineSummaryEditor;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/shared-ugc-editors/lib/components/inline-summary-editor/components/InlineSummaryEditor.js
// module id = 1520
// module chunks = 1